module.exports = __webpack_public_path__ + "img/sure-desktop.bdb7391f.svg";